import { Component, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationExtras } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { ModuleControl, UserLogService, UserService, Person, ParameterProvider } from 'cw-backend';
import { CwUtils, SnackBarService } from 'cw-utils';
import { AuthService } from 'cw-services';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Eartefact } from '../../../../../../shared/cw-backend/models/others/eartefact';
import { ModalDefaultersComponent } from 'app/main/modals/modal-defaulters/modal-defaulters.component';
import { MetaService } from '../../../../../../shared/cw-backend/providers/system/meta/meta.service';


@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    roleNavigation: ModuleControl;
    eartefact = new Eartefact();
    isDecember: boolean;
    isOctober: boolean;
    isNovember: boolean;
    isSeptember: boolean;
    data = new Date().toISOString().slice(0, 10);
    private readonly initialScreenMetaKey = "INITIAL_SCREEN";

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        public _dialog: MatDialog,
        private authService: AuthService,
        private router: Router,
        private snackBar: SnackBarService,
        private userService: UserService,
        private metaService: MetaService,
        private userLogService: UserLogService,
        private progressBar: FuseProgressBarService,
        private parameterProvider: ParameterProvider
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    ngOnInit(): void {  
        const currentMonth = new Date().getMonth(); // Retorna o mês atual (0 = Janeiro, 11 = Dezembro)
        this.isNovember = currentMonth === 10;
        this.isOctober = currentMonth === 9;
        this.isDecember = currentMonth === 11;
        this.isSeptember = currentMonth === 8;
        this.parameterProvider
            .getByNameNotAuthentication("LOGO_DEFAULT")
            .then((res) => {
                if (res.value != null) {
                    this.userService.getInfoCompany(res.value).then((res) => {
                        this.eartefact = res;
                    });
                }
            });
        // $('#user_login').focus();
        this.loginForm = this._formBuilder.group({
            login: ["", [Validators.required]],
            password: ["", [Validators.required]],
            userRtv: [""],
            acceptTermsUse: [""],
        });
    }

    async showDialog(token, statusClient) {

        return new Promise((resolve, reject) => {
            const dialogRef = this._dialog.open(ModalDefaultersComponent, {
               // height: "70%",
               // maxHeight: "70%",
               // width: "50%",
               // maxWidth: "50%",
                panelClass: 'clearPadding',
                disableClose: true,
            });
            dialogRef.componentInstance.status = statusClient;
            dialogRef.componentInstance.token = token;
            dialogRef.afterClosed().subscribe((result) => {
                this.confirmDefaulter(token);
                if(statusClient == "BLOCKED"){
                    resolve(false);
                }else{
                    resolve(result);
                }
            });
        })

    }

    confirmDefaulter(token) {
        this.metaService.confirmDefaultersWithToken(token).then(() => { });
    }

    login() {
        const data = this.loginForm.getRawValue();

        if (data.login != "admin") {
            data.userRtv = null;
        } else {
            localStorage.setItem("userRtv", data.userRtv);
        }

        this.progressBar.show();
        this.userService.login(data).then(
            async (res) => {

                // get token from header
                let token = res.headers.get("X-Auth-Token");
                if (!token) {
                    this.snackBar.unexpectedMessage();
                    return;
                }

                if (res.body?.statusClient === "DEFAULTERS" || res.body?.statusClient === "BLOCKED") {
                  let result =  await this.showDialog(token, res.body?.statusClient);

                  if(!result){
                    this.progressBar.hide();
                    this.userService.logout();
                    return;
                  }
                }

                // set user's credencial in localstorage
                this.authService.setAuthenticated(token, res.body);


                // set user's permissions
                this.getPermissions().then(async () => {
                    // set time of login in localstorage
                    this.userLogService.setUserLogAcess();
                    // get last logons of user
                    this.userLogService.getUserLastLogons();
                    // redirect
                    this.progressBar.hide();

                    const initialScreenUrl = await this.getInitialScreenUrl(
                        res.body?.id,
                    );

                    if (initialScreenUrl) {
                        this.router.navigateByUrl(initialScreenUrl);
                    } else if (
                        this.router.url === "/auth/login" &&
                        res.body?.performerId
                    ) {
                        sessionStorage.setItem("last_component", "login");
                        this.router.navigate([
                            "operacional/atendimento/agenda-profissional",
                        ]);
                    } else {
                        this.router.navigate(["aplicacao/dashboards/admin"]);
                    }
                    sessionStorage.removeItem("scheduleReception");
                });
            },
            (error) => {
                const UserExecption = error.error;
                if (error.status == 0) {
                    this.snackBar.unexpectedMessage();
                } else
                    switch (UserExecption.code) {
                        case "PASSWORD_EXPIRED":
                            this.resetPassword(this.loginForm.value);
                            break;
                        case "PENDING_ACCEPT_TERMS_USE":
                            this.termsOfUseDialog();
                            break;
                        default:
                            this.snackBar.errorMessage(UserExecption.message);
                            break;
                    }
                this.progressBar.hide();
            }
        );
    }

    termsOfUseDialog() {
        const dialogRef = this._dialog.open(TermsOfUseComponent);
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.loginForm.controls["acceptTermsUse"].setValue(result);
                this.login();
                // const data = this.loginForm.getRawValue();
                // this.userService.login(data).then(() => { });
                // this.resetPassword(this.loginForm.value)
            }
        });
    }

    resetPassword(user) {
        const navigationExtras: NavigationExtras = {
            state: { user: user },
        };
        this.router.navigate(["auth/redefinir-senha"], navigationExtras);
    }

    loginDigital() {
        this.router.navigate(["aplicacao/dashboards/admin"]);
    }

    async getInitialScreenUrl(userId: number): Promise<string> {
        if (!userId) {
            return "";
        }

        try {
            const res: any = await this.userService.getUserMeta(
                userId,
                this.initialScreenMetaKey,
            );
            const url = (res?.body || "").replace(/^\//, "");

            return url ? `/${url}` : "";
        } catch {
            return "";
        }
    }

    async getPermissions() {
        return await this.userService.getPermissions().then((res) => {
            this.authService.setPermission(res.body.modules);
        });
    }
}

@Component({
    selector: 'terms-of-use',
    templateUrl: 'terms-of-use.component.html',
})

export class TermsOfUseComponent {
}
